import { useState } from 'react';
import UserForm from '../../components/user/userForm';

const EditUser = () => {

    const [user, setUser] = useState({
        email: '',
        password: '',
        name: ''
    })

    return <UserForm />
}

export default EditUser;
